import { UnitAmount } from '@/domain/stripe/quote/model/UnitAmount'

export class Price {
  constructor(
    public readonly id: string,
    public readonly unitAmount: UnitAmount,
  ) {
  }
}
